import React, { Component } from "react";
import { BloxButton as Button } from "styled_components/Common/BloxButton";
import BloxButton from "sub_components/Common/BloxButton";
import LoadingCube from "sub_components/Common/LoadingCube";
import { connect } from "react-redux";
import { RESOLUTIONS } from "services/config";
import format from "date-fns/format";
import { Divider } from "styled_components/Common/Divider";
import { TYPES, SEVERITIES } from "utils/TicketConstants";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { SuccessMessage, ErrorMessage } from "utils/CommonConstants";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { TicketApi } from "services/ticket";
import { Utils } from "services/utils";
import { StorageApi } from "services/storage";
import { CredentialModalBody } from "styled_components/Storage/CredentialModalBody";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const swiftLogo = `${CDN_URL}common/swiftstack-logo.svg`;
const s3Logo = `${CDN_URL}common/s3-logo-md.svg`;
const viewOpenSelected = `${CDN_URL}common/view-open-enabled-lg.svg`;
const viewOpenHover = `${CDN_URL}common/view-open-hover-lg.svg`;

class ConfigDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      shares: [],
      share: null,
      showPassword: false,
      showApiKey: false,
      selectedType: null,
      selectedData: null,
      changePassword: false,
      changeRequested: false,
      requestType: null,
      showModal: false,
    };
  }

  componentDidMount() {
    const { share, security } = this.props;
    if (share && security) {
      this.setData();
    }
  }

  componentDidUpdate(prevProps) {
    const { share, security } = this.props;

    if (share !== prevProps.share || security !== prevProps.security) {
      this.setState({ share, selectedType: null }, () => {
        this.setData();
      });
    }
  }
  setData = () => {
    const { selectedType: currentType } = this.state;
    const { breakpoint, security } = this.props;
    let selectedData = [];
    const swiftSecurity =
      security && security.filter((s) => s.credential_type === "swift");
    const s3Security =
      security && security.filter((s) => s.credential_type === "s3");

    let selectedType = currentType ? currentType : "s3";

    if (security && security.length === 1) {
      selectedType = security?.[0]?.credential_type;
    }
    if (selectedType === "s3") {
      selectedData = [
        { label: "Service Point", value: s3Security?.[0]?.auth_url },
        { label: "Use SSL", value: "Yes" },
        { label: "View Secret Key", value: "", hide: true },
        { label: "Configuration" },
      ];
    } else {
      if (breakpoint === RESOLUTIONS.LOW) {
        selectedData = [
          { label: "Auth URL", value: swiftSecurity?.[0]?.auth_url },
          { label: "Username", value: swiftSecurity?.[0]?.access_key },
          { label: "View Password", value: "", hide: true },
          { label: "Configuration" },
        ];
      } else {
        selectedData = [
          { label: "Auth URL", value: swiftSecurity?.[0]?.auth_url },
          { label: "Auth Type", value: "v1" },
          { label: "Username", value: swiftSecurity?.[0]?.access_key },
          { label: "View Password", value: "", hide: true },
          { label: "Configuration" },
        ];
      }
    }
    this.setState({ selectedData, selectedType });
  };

  updateSelected = (selectedType) => {
    this.setState(
      { selectedType, showPassword: false, changePassword: false },
      () => {
        this.setData();
      }
    );
  };

  formatDescription = (auth_status) => {
    const {
      user: { firstname, lastname },
    } = auth_status;
    const { share } = this.props;
    let description = "";
    description += `Share Name: ${share.common_name}\n `;
    description += `Share Id: ${share?.storage_id}\n `;
    description += `Requestor: ${firstname}  ${lastname} \n`;

    // Add shared user information if available
    const sharedUserData = sessionStorage.getItem("sharedUser");
    if (sharedUserData) {
      const { name, email } = JSON.parse(sharedUserData);
      description += `Shared User Name: ${name}\n`;
      description += `Shared User Email: ${email}\n`;
    }

    description += `Time: ${format(new Date(), "HH:mm")}`;
    return description;
  };

  setConfirmationModal = () => {
    const { setModalContent } = this.props;
    const { changeRequested, requestType } = this.state;

    if (changeRequested) {
      const headerText =
        requestType === "Password"
          ? `ARE you sure you want to change your password , this will also change the Secret Key ?`
          : "ARE you sure you want to change your secret key ?";

      const button = (
        <Button
          className="buttons41"
          id="continue"
          text="Yes"
          module="storage"
          enabled={true}
          onClick={this.onConfirm}
          cypressId="continue"
        />
      );

      setModalContent(false, headerText, button);
    }
  };
  onChangeRequest = () => {
    const { selectedType } = this.state;

    const incomingRequestType =
      selectedType === "s3" ? "Secret Key" : "Password";
    this.setState(
      { changeRequested: true, requestType: incomingRequestType },
      () => this.setConfirmationModal(incomingRequestType)
    );
  };

  onConfirm = () => {
    const { requestType } = this.state;
    const { setModalContent } = this.props;
    setModalContent("CLOSE");
    this.changePassword(requestType);
  };

  changePassword = () => {
    const {
      setModalContent,
      refreshSecurity,
      share,
      company_info: {
        customer: { id },
      },
      ticketType,
    } = this.props;
    const { requestType, selectedType } = this.state;

    const params = {
      type: selectedType,
    };
    const button = (
      <Button
        className="buttons41"
        id="okay"
        text="OKAY"
        module="storage"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );

    StorageApi.changeStoragePassword(params, id, share?.storage_id)
      .then((response) => {
        if (response.status === 200 && !response.data.error) {
          setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
          if (refreshSecurity) {
            refreshSecurity();
          }
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);

          if (ticketType?.bonita) {
            this.createChangePasswordTicket(requestType);
          }
        }
      })
      .catch(() => {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);

        if (ticketType?.bonita) {
          this.createChangePasswordTicket(requestType);
        }
      });
  };

  createChangePasswordTicket = async (requestType) => {
    const { changePassword } = this.state;
    const {
      site,
      company_info,
      auth_status,
      share,
      setModalContent,
      auth_status: {
        user: {
          userProfile: { emailAddress },
        },
      },
    } = this.props;

    const type = TYPES.STORAGE;
    const priority = SEVERITIES.LOW;
    const description = this.formatDescription(auth_status);
    const title = ` Change ${requestType} `;
    const browserInfo = await Utils.getClientParams(site);
    const userId = auth_status.user.id;
    const companyId = company_info?.customer?.id;
    const newTicket = {
      requester: Utils.getRequester(auth_status),
      requester_contact_type: "",
      requester_contact_value: emailAddress,
      internalTicketReference: "",
      requester_id: userId,
      record_id: share?.storage_id,
      invite_id: "",
      public_request: null,
      status: "New",
      title,
      description,
      priority,
      internal_priority: priority,
      type,
      request_type: type,
      request_method: "",
      service: "storage",
      process_id: 0,
      companyId,
      userId,
      jira_ticket: "",
      location: "",
      impact_to_customer: "None",
      impact_to_dcblox: "None",
      resolution_notes: "",
      general_support_question_type: "",
      general_support_question: "",
      general_support_equipment: "",
      feedback_type: "",
      feedback_jira_ticket: "",
      feedback_browser_data: browserInfo,
      billing_detail: [],
      outage_details: [],
      related_tickets: [],
      assignes: [],
      request_log: [],
      comments: [],
      attachments: [],
      notifications: [],
      related_services: [],
      test_results: [],
    };
    const button = (
      <Button
        className="buttons41"
        id="okay"
        text="OKAY"
        module="storage"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    TicketApi.createTicket(newTicket)
      .then((response) => {
        if (response.status === 200 && !response.data.error) {
          sessionStorage.removeItem("tickets");

          setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
        }
      })
      .catch(() => {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      });

    this.setState({ changePassword: !changePassword });
  };
  checkShareSize = (share) => {
    if (
      share.currentSizeTB ||
      share.currentSizeGB ||
      share.currentSizeMB ||
      share.currentSizePB
    ) {
      return false;
    } else {
      return true;
    }
  };
  addActive = (e) => {
    e.target.classList.add("active");
  };
  removeActive = (e) => {
    e.target.classList.remove("active");
  };

  showModal = () => {
    this.toggleModal();
  };

  mapSelectedData = (selectedData) => {
    return selectedData.map((item) => (
      <div className="detail-row" key={item.label}>
        <Divider />
        <div className="label labels21">{item.label}</div>
        {!item.hide && item?.value && (
          <div className="value footer20">{item.value}</div>
        )}
        {item.hide && (
          <div className="value footer20">
            {item.label !== "Password" && (
              <>
                <div
                  data-cy="change-credentials"
                  className="left-icon keys"
                  onClick={this.showModal}
                >
                  <img
                    src={viewOpenHover}
                    id="view"
                    onMouseOver={(e) => (e.target.src = viewOpenSelected)}
                    onMouseOut={(e) => (e.target.src = viewOpenHover)}
                  />
                </div>
                <div className={"password keys"} onClick={this.showModal}>
                  {item.value}
                </div>
              </>
            )}
          </div>
        )}
        {item.label === "Configuration" && (
          <div className="configurations">
            <a
              href="/cdn/library/common/Storage_Walkthrough_CloudBerry.pdf"
              download="Storage_Walkthrough_CloudBerry.pdf"
            >
              <div
                className="link footer20"
                onClick={this.addActive}
                onMouseOut={this.removeActive}
              >
                CloudBerry
              </div>
            </a>
            <a
              href="/cdn/library/common/Storage_Walkthrough_MAC.pdf"
              download="Storage_Walkthrough_MAC.pdf"
            >
              <div
                className=" link footer20"
                onClick={this.addActive}
                onMouseOut={this.removeActive}
              >
                Mac/Linux
              </div>
            </a>
            <a
              href="/cdn/library/common/Storage_Walkthrough_Windows.pdf"
              download="Storage_Walkthrough_Windows.pdf"
            >
              <div
                className="link footer20"
                onClick={this.addActive}
                onMouseOut={this.removeActive}
              >
                Windows
              </div>
            </a>
          </div>
        )}
      </div>
    ));
  };

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  };

  mapSecurity = (security, selectedType) => {
    return security.map((cred) => (
      <BloxButton
        title={cred?.credential_type ? cred?.credential_type.toUpperCase() : ""}
        customClass={
          selectedType === cred?.credential_type
            ? "blox-button selected"
            : "blox-button"
        }
        onClick={() => this.updateSelected(cred?.credential_type)}
        enabled
        cypressId={cred?.credential_type}
      />
    ));
  };

  getSize = (breakpoint) => {
    let size = "medium";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };

  getSecurity = (security, type) => {
    return security && security.filter((s) => s.credential_type === type);
  };

  isShareDeleted = (share) => {
    return share?.status === "deleted" || share?.status === "pending_delete"
      ? "deleted"
      : "";
  };

  isSharePending = (share) => {
    return share?.status === "pending" || share?.status === "processing"
      ? "pending"
      : "";
  };

  getModalFooter = (selectedType, updateConfig, breakpoint) => {
    return (
      <ModalFooter
        cypressId="footer"
        id="footer"
        buttonText1={
          selectedType === "s3" ? "Reset Secret Key" : "Reset Password"
        }
        buttonText2="Back"
        buttonActive1={true}
        buttonActive2={true}
        module="storage"
        buttonFunction1={updateConfig ? () => this.onChangeRequest() : () => {}}
        size={this.getSize(breakpoint)}
      />
    );
  };

  render() {
    const { selectedType, selectedData, showModal } = this.state;
    const { share, loading, security, breakpoint, updateConfig } = this.props;
    const pending = this.isSharePending(share);
    const deleted = this.isShareDeleted(share);
    const swiftSecurity = this.getSecurity(security, "swift");
    const s3Security = this.getSecurity(security, "s3");

    return (
      <>
        {!security && loading && <LoadingCube />}
        {!security && !loading && (
          <div className="body10">Error getting share details.</div>
        )}
        {security && (
          <div className="config-details-container">
            <div className="overlay">
              {pending === "pending" && (
                <div className="title heading60">PROVISIONING</div>
              )}
              {deleted === "deleted" && (
                <div className="title heading60">DELETED</div>
              )}
            </div>

            <div className={`details-wrapper ${pending} ${deleted}`}>
              {share && security && security.length !== 0 && (
                <>
                  <div className="buttons-wrapper">
                    {security && this.mapSecurity(security, selectedType)}
                  </div>
                  <div className="icon">
                    <img src={selectedType === "s3" ? s3Logo : swiftLogo} />
                    {share.status === "active" &&
                      this.checkShareSize(share) && (
                        <div className="new-banner headings70">NEW!</div>
                      )}
                  </div>
                  <div className="details">
                    {selectedData && this.mapSelectedData(selectedData)}

                    <PortraitModalComponent
                      closeModal={this.toggleModal}
                      show={showModal}
                      breakpoint={breakpoint}
                      header={
                        <ModalHeader
                          image={selectedType === "s3" ? s3Logo : swiftLogo}
                          text={""}
                          className="guest"
                        />
                      }
                      title={selectedType === "s3" ? "Secret Key" : "Password"}
                      subTitle={
                        selectedType === "s3"
                          ? `This is the secret key for this storage account`
                          : `This is the password for this storage account`
                      }
                      size={this.getSize(breakpoint)}
                    >
                      <CredentialModalBody
                        security={
                          selectedType === "s3"
                            ? s3Security[0]
                            : swiftSecurity[0]
                        }
                      />

                      {this.getModalFooter(
                        selectedType,
                        updateConfig,
                        breakpoint
                      )}
                    </PortraitModalComponent>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site_tracking,
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps, null)(ConfigDetails);
